import { render, staticRenderFns } from "./iosRedirect.vue?vue&type=template&id=2ea14052&"
import script from "./iosRedirect.vue?vue&type=script&lang=js&"
export * from "./iosRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports